import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from '../http/api';
import { Filter, FilterBuilder } from '../http/filter';
import { DetailRequest, DetailRequestBuilder } from '../http/detail';
import { Collection } from '../http/collection';
import { LIBRARY } from "@app/evaluation/library";
import { SessionStorage } from "@core/browser";
import { Library } from "@library";
import { Observable } from "rxjs";
import { OrganizationProtocolPreference } from '@core/data/types/custom-protocol';

@Injectable()
export class OrganizationProtocolPreferencesService {

    constructor(
        private _http: HttpClient,
        @Inject(API_BASE_URI) private _baseUri: string,
        @Inject(LIBRARY) private _library: Library,
        @Inject(SessionStorage) private _session: SessionStorage
    ) {}

    query(filter: Filter, detail?: DetailRequest) {
            let params = {
                ...DetailRequestBuilder.queryParams(detail),
                ...FilterBuilder.queryParams(filter),
            };

            return this._http.get<Collection<OrganizationProtocolPreference>>(`${this._baseUri}/organizations/protocol/preferences`, {params});
        }

    create(model: Partial<OrganizationProtocolPreference>) {
        return this._http.post<OrganizationProtocolPreference>(`${this._baseUri}/organizations/protocol/preferences`, model);
    }

    read(key: string, detail?: DetailRequest): Observable<OrganizationProtocolPreference> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<OrganizationProtocolPreference>(`${this._baseUri}/organizations/protocol/preferences/${key}`, {params});
    }

    update(key: string, model: Partial<OrganizationProtocolPreference>) {
        return this._http.put<OrganizationProtocolPreference>(`${this._baseUri}/organizations/protocol/preferences/${key}`, model);
    }

    delete(key: string) {
        return this._http.delete<OrganizationProtocolPreference>(`${this._baseUri}/organizations/protocol/preferences/${key}`);
    }
}